import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CircularProgress from '@mui/material/CircularProgress';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import AsyncSelect from 'react-select/async';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { fetchData, updateData, postData } from '../../../apiService';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Tooltip, Modal } from '@material-ui/core';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';


const PurchaseOrderEdit = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL  
    const [selectedItems, setSelectedItems] = useState([]);
    const [orderDetails, setOrderDetails] = useState({});
    const [supplier, setSupplier] = useState('');
    const [supplierItems, setSupplierItems] = useState([]);
    const [checkedItems, setCheckedItems] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [formData, setFormData] = useState([]);
    const [orderdeatils, setOrderdeatils] = useState([]);
    const [requestdeatils, setRequestdeatils] = useState([]);
    const [selectedInvoiceType, setSelectedInvoicetype] = useState("");
    const [dropdownInvoiceTypeOptions, setDropdownInvoiceTypeOptions] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const history = useHistory();
    const [itemOptions, setItemOptions] = useState([]);
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [invoicedeatils, setInvoicedeatils] = useState([]);

    useEffect(() => {
        // Check if reload is needed based on the flag set in localStorage
        const shouldReload = localStorage.getItem('shouldReloadCreatePage') === 'true';

        if (shouldReload) {
            localStorage.removeItem('shouldReloadCreatePage'); // Remove the flag after use
            window.location.reload(); // Reload the page once
        }

        // Authentication and token expiration handling
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        // Other initializations, if any
    }, [isAuthenticated, token, logout]);


    const fetchOptions = async (inputValue) => {
        if (inputValue.length <= 2) {
            return [];
        }


        try {
            const response = await fetchData('PurchaseOrderApi', `/Party/${companyId}/${branchId}/${inputValue}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                if (Array.isArray(data)) {
                    setSupplierOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.Name,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };

    const handleCustomerSelect = (selectedOption) => {
        setSelectedOption(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            MasterId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
        }));

        if (!selectedOption) return;

        const selectedItemId = selectedOption.value;
        const selectedSupplierRetail = supplierOptions.find((itemDetail) => itemDetail.Id === selectedItemId);
        const suppliertaxno = selectedSupplierRetail?.TaxNumber ?? '';
        const InvoiceTypeId = selectedSupplierRetail?.InvoiceTypeId ?? '';
        const InvoiceTypeName = selectedSupplierRetail?.InvoiceTypeName ?? '';

        setFormData(prevData => ({
            ...prevData,
            InvoiceTypeId: InvoiceTypeId,
            InvoiceTypeName: InvoiceTypeName,
            TaxNumber: suppliertaxno,
            CreatedBy: userId,
        }));

    };

    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItem, setSelectedItem] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    useEffect(() => {
        fetchItemOptions();
    }, []);

    const handleInputChange = (newValue) => newValue;
    const handleItemChange = (newValue) => newValue;
    const fetchItemOptions = async (inputValue = '') => {
        // Early return if input value is empty or too short
        if (!inputValue || inputValue.length <= 1) {
            return [];
        }


        try {
            // Fetch data from the API
            const response = await fetchData('PurchaseOrderApi', `/Item/${companyId}/${branchId}/${inputValue}`, token);

            // Check if the response code is 1111
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                // Ensure the response data is an array
                if (Array.isArray(data)) {
                    setItemsrOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.ItemName1,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching item options:', error);
            return [];
        }
    };

    const [itemdetails, setItemDetails] = useState([]);
    const [customerdetails, setCustomerDetails] = useState([]);
    //Items    

    useEffect(() => {
        fetchItems();
    }, []);

    const fetchItems = async () => {
        try {
            const response = await fetchData('PurchaseOrderApi', `/Item/${companyId}/${branchId}`, token);
            if (response.responseCode === '1111') {
                setItemDetails(response.response_data);
            }

            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;

            setFormData(prevData => ({
                ...prevData,
                BillDate: formattedDate,
                PurchaseBillDate: formattedDate,
                BranchId: branchId,
                CompanyId: companyId,
                CreatedBy: userId,
            }));

        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleChangeDrop = (selectedOption) => {
        setSelectedItemOption(selectedOption);

        const selectedItemId = selectedOption ? selectedOption.value : '';
        const selectedItemDetail = itemdetails.find((itemDetail) => itemDetail.Id === selectedItemId);

        if (selectedItemDetail) {

            // const quantity = parseFloat(modalData.Quantity) || 0;
            const quantity = parseFloat(modalData.OrderedQuantity);
            const rate = '';  //parseFloat(selectedItemDetail.PurchaseRate.toFixed(2)) || 0;
            const taxrate = parseFloat(selectedItemDetail.TaxRate.toFixed(2)) || 0;
            const amount = (quantity * rate).toFixed(2);
            let taxamt = 0;
            if (taxrate > 0) {
                taxamt = ((amount * taxrate) / 100).toFixed(2);
            }
            const totalAmount = (parseFloat(amount) + parseFloat(taxamt)).toFixed(2);

            setModalData({
                ...modalData,
                Rate: rate, //selectedItemDetail.PurchaseRate.toFixed(2), // Assuming Rate is a number
                TaxRate: taxrate,
                ItemName: selectedOption ? selectedItemDetail.Name : '',
                ItemId: selectedOption ? selectedOption.value : '',
                Amount: amount,
                TaxableAmount: amount,
                TaxAmount: taxamt,
                TotalAmount: totalAmount,
                RequestedQuantity: quantity,
            });

        } else {
            // Handle the case where the item detail is not found
            setModalData({
                ...modalData,
                Rate: '',
                TaxRate: '0.00',
                ItemName: selectedOption ? selectedItemDetail.Name : '',
                ItemId: selectedOption ? selectedOption.value : '',
                Amount: '0.00',
                TaxAmount: '0.00',
                TotalAmount: '0.00',
                GSTAmt: '0.00',
                RequestedQuantity: '',
            });
        }
    };




    const handleModalInputChange = (e) => {
        const { name, value } = e.target;
        setModalData({
            ...modalData,
            [name]: value,
        });

        if (name === 'OrderedQuantity') {
            const quantity = parseFloat(value) || 0;
            const rate = parseFloat(modalData.Rate) || 0;
            const taxrate = parseFloat(modalData.TaxRate) || 0;
            const amount = (quantity * rate).toFixed(2);
            let taxamt = 0;
            if (taxrate > 0) {
                taxamt = ((amount * taxrate) / 100).toFixed(2);
            }
            const totalAmount = (parseFloat(amount) + parseFloat(taxamt)).toFixed(2);

            setModalData({
                ...modalData,
                OrderedQuantity: value,
                Rate: modalData.Rate,
                Amount: amount,
                TaxableAmount: amount,
                TaxAmount: taxamt,
                TotalAmount: totalAmount,
            });
        }
        else if (name === 'Rate') {
            const quantity = parseFloat(modalData.OrderedQuantity) || 0;
            const rate = parseFloat(value) || 0;
            const taxrate = parseFloat(modalData.TaxRate) || 0;
            const amount = (quantity * rate).toFixed(2);
            let taxamt = 0;
            if (taxrate > 0) {
                taxamt = ((amount * taxrate) / 100).toFixed(2);
            }
            const totalAmount = (parseFloat(amount) + parseFloat(taxamt)).toFixed(2);
            setModalData({
                ...modalData,
                Rate: value,
                OrderedQuantity: modalData.OrderedQuantity,
                Amount: amount,
                TaxableAmount: amount,
                TaxAmount: taxamt,
                TotalAmount: totalAmount,
            });
        }
    };

    //// modalData 
    // FOR MODEL DATA (Invoice Details)
    const [selectedItemOption, setSelectedItemOption] = useState(null);

    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName1: '',
        ItemId: '',
        RequestedQuantity: '',
        OrderedQuantity: '',
        Rate: '',
        Amount: '',
        TaxRate: '',
        TaxAmount: '',
        TotalAmount: '',
    });

    const closeModal = () => {
        setModalData({
            SlNo: '0',
            ItemName1: '',
            ItemId: '',
            RequestedQuantity: '',
            OrderedQuantity: '',
            Rate: '',
            Amount: '',
            TaxRate: '',
            TaxAmount: '',
            TotalAmount: '',
        });
        setSelectedItem();
        setIsModalOpen(false);
    };

    const saveModalData = () => {
        let isValid = true;
        let errors = "";
        setErrorMessageModel(errors);

        // Validation for ItemId
        if (!modalData.ItemId) {
            isValid = false;
            errors = "Item is required";
        }

        // Validation for Quantity
        if (!modalData.OrderedQuantity || isNaN(modalData.OrderedQuantity)) {
            isValid = false;
            errors = "Quantity must be a valid number";
        }



        if (isValid) {
            //setInvoicedeatils([...invoicedeatils, modalData]);
            const updatedInvoicedetails = [...selectedItems, modalData];
            const updatedInvoicedetailsSorted = updatedInvoicedetails.reverse();
            setSelectedItems(updatedInvoicedetailsSorted);

            setModalData({
                ...modalData,
                SlNo: '0',
                ItemName1: '',
                ItemId: '',
                OrderedQuantity: '',
                RequestedQuantity: '',
                Rate: '',
                Amount: '',
                TaxRate: '',
                TaxAmount: '',
                TotalAmount: '',
            });

            setSelectedItemOption(null); // Clear AsyncSelect
            fetchItemOptions('');
            //closeModal();

            //Update the totals based on the updatedItemData
            const Quantity = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const TaxAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TaxAmount), 0);
            const TotalAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const TaxableAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);

            let Freight = parseFloat(formData.Freight) || 0;
            let TCSAmount = parseFloat(formData.TCSAmount) || 0;
            let DiscountAmount = parseFloat(formData.DiscountAmount) || 0;
            const PaidAmount = parseAndFix(formData.PaidAmount);

            totalCalculation(Quantity, Amount, TaxAmount, TotalAmount, Freight, DiscountAmount, TaxableAmount);


        } else {

            console.log("Validation errors:", errors);
            // setErrorMessageModel(errors);
        }

    };


    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (formData.SupplierId == 0) {
            setErrorMessage('Supplier is required !');
            setIsLoading(false);
            return;
        }


        if (!selectedItems || selectedItems.length === 0) {
            setErrorMessage('Item Details are required!');
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            CreatedBy: userId,
            BranchId: branchId,
            CompanyId: companyId,
        }));

        const CreateData = {
            PurchaseOrder: formData,
            PurchaseOrderDetails: selectedItems
        };

        // Validate form data here if needed

        updateData('PurchaseOrderApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                const SaleId = response.kotId;
                // handlePrint(SaleId);
                history.push('/PurchaseOrderIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };


    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };



    // Handle checkbox selection
    const handleItemCheck = (itemId) => {
        setCheckedItems((prev) =>
            prev.includes(itemId) ? prev.filter((id) => id !== itemId) : [...prev, itemId]
        );
    };

    // Add selected items to the second table on "OK" button click
    const handleOkClick = () => {
        const itemsToInsert = requestdeatils.filter((item) =>
            checkedItems.includes(item.PurchaseRequestId)
        );
        setSelectedItems(itemsToInsert);
    };


    // Helper function to parse and handle NaN values as 0
    const parseAndFix = (val) => parseFloat(val) || 0;
    const [orderQuantities, setOrderQuantities] = useState({});

    const calculateItemData = (item, formData) => {
        let rate = parseAndFix(item.Rate);
        let quantity = parseAndFix(item.OrderedQuantity);
        let taxRate = parseAndFix(item.TaxRate);

        let Discper = parseAndFix(item.DiscountPercentage);
        let Addidiscamt = ((rate * Discper) / 100).toFixed(2)
        let totdiscount = parseFloat(Addidiscamt);
        let grate = (rate - totdiscount).toFixed(2);
        let amt = (quantity * rate).toFixed(2);
        let amount = (quantity * grate).toFixed(2);
        let taxAmount = 0;
        if (taxRate > 0) {
            taxAmount = ((amount * taxRate) / 100).toFixed(2);
        }

        const totalAmount = parseAndFix(amount) + parseAndFix(taxAmount);

        return {
            ...item,
            RequestedQuantity: quantity,
            Amount: amt,
            TaxableAmount: amount,
            TaxRate: taxRate,
            TaxAmount: taxAmount,
            TotalAmount: totalAmount.toFixed(2),
            DiscountAmount: parseAndFix(totdiscount * quantity).toFixed(2),
        };
    };


    const totalCalculation = (Quantity, Amount, TaxAmount, TotalAmount, Freight, DiscountAmount, TaxableAmount) => {
        const safeQty = parseAndFix(Quantity);
        const safeAmt = parseAndFix(Amount);
        const safeTax = parseAndFix(TaxAmount);
        const safeFreight = parseAndFix(Freight);
        const safeDisc = parseAndFix(DiscountAmount);
        const safeTaxable = parseAndFix(TaxableAmount);

        let netAmount = safeTaxable + safeTax + safeFreight;
        let roundOff = Math.round(netAmount) - netAmount;
        let grandTotal = netAmount + roundOff;

        setFormData((prev) => ({
            ...prev,
            TotalQuantity: safeQty,
            Amount: safeAmt.toFixed(2),
            TaxableAmount: safeTaxable.toFixed(2),
            TaxAmount: safeTax.toFixed(2),
            RoundOff: roundOff.toFixed(2),
            TotalAmount: grandTotal.toFixed(2),
            DiscountAmount: safeDisc.toFixed(2),
            FreightAmount: safeFreight.toFixed(2),
            ModifiedBy: userId,
        }));
    };

    const handleCalculation = (e, index, inputType) => {
        let name, value;
        if (typeof e === 'object') {
            name = e.target.name;
            value = e.target.value;
        } else {
            name = inputType;
            value = e;
        }

        // Assuming selectedItems is a state setter function (e.g., setSelectedItems)
        setSelectedItems((prevDetails) => {
            const newDetails = [...prevDetails];
            newDetails[index] = {
                ...newDetails[index],
                [name]: value,
            };

            const updatedItemData = newDetails.map((item) => calculateItemData(item, formData));

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.RequestedQuantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.TaxAmount += parseAndFix(item.TaxAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    return acc;
                },
                { Quantity: 0, Amount: 0, TaxAmount: 0, TotalAmount: 0, DiscountAmount: 0, TaxableAmount: 0 }
            );

            const Freight = parseAndFix(formData.FreightAmount);

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.TaxAmount,
                totals.TotalAmount,
                Freight,
                totals.DiscountAmount,
                totals.TaxableAmount,
            );

            return updatedItemData;
        });
    };


    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        // Immediate update of the input field
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));

        const updateFormDataAndDetails = (key, value) => {
            const fixedValue = parseAndFix(value).toFixed(2);
            setFormData((prevData) => ({
                ...prevData,
                [key]: fixedValue,
                ModifiedBy: userId,
            }));

            const updatedItemData = selectedItems.map((item) => calculateItemData(item, formData));

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.RequestedQuantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.TaxAmount += parseAndFix(item.TaxAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    return acc;
                },
                { Quantity: 0, Amount: 0, TaxAmount: 0, TotalAmount: 0, DiscountAmount: 0, TaxableAmount: 0 }
            );

            const Freight = parseAndFix(value);

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.TaxAmount,
                totals.TotalAmount,
                Freight,
                totals.DiscountAmount,
                totals.TaxableAmount,
            );

        };

        if (name === 'FreightAmount') {
            updateFormDataAndDetails(name, value);
        }
    };

    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = selectedItems.filter((_, i) => i !== itemToDeleteIndex);
            setSelectedItems(updatedItemList);

            const updatedItemData = updatedItemList.map((item) => calculateItemData(item, formData));

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.RequestedQuantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.TaxAmount += parseAndFix(item.TaxAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    return acc;
                },
                { Quantity: 0, Amount: 0, TaxAmount: 0, TotalAmount: 0, DiscountAmount: 0, TaxableAmount: 0 }
            );

            const Freight = parseAndFix(formData.FreightAmount);

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.TaxAmount,
                totals.TotalAmount,
                Freight,
                totals.DiscountAmount,
                totals.TaxableAmount,
            );

            closeConfirmDialog();
        }
    };


    useEffect(() => {
        fetchData('PurchaseOrderApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.PurchaseOrder);
                    setSelectedItems(response.response_data.PurchaseOrderDetails);


                    setSelectedInvoicetype({
                        value: response.response_data?.PurchaseOrder?.InvoiceTypeId ?? 1, // Fallback to 1 if null
                        label: response.response_data?.PurchaseOrder?.InvoiceTypeName ?? 'B To B' // Fallback to 'B To B' if null
                    });

                    setSelectedOption({
                        value: response.response_data?.PurchaseOrder?.MasterId ?? 1, // Fallback to 1 if null
                        label: response.response_data?.PurchaseOrder?.SupplierName ?? '' // Fallback to 'B To B' if null
                    });

                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);


      //handle search [ITEM SEARCH]
      const [isFocused, setIsFocused] = useState(false);
      const [searchQuery, setSearchQuery] = useState('');
      const [showSearchInput, setShowSearchInput] = useState(false);
  
      const handleSearch = (event) => {
          setSearchQuery(event.target.value);
      };
  
      const toggleSearchInput = () => {
          setShowSearchInput(!showSearchInput);
      };
  
      //search
      const filteredData = selectedItems.filter((item) =>
          Object.values(item).some((value) =>
              String(value).toLowerCase().includes(searchQuery.toLowerCase())
          )
      );
      
    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ maxWidth: '100%', marginTop: '-25px' }}>

            <div className="flex justify-between items-center mb-4">
                <h6
                    className="block uppercase tracking-wide text-black flex-grow"
                    style={{
                        fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                        color: 'black',
                        width: '40%',
                        marginTop: '20px',
                        marginLeft: '10px'
                    }}
                >
                    Purchase Order Edit
                </h6>

                <div className="mt-8">

                    <Button
                        style={{ marginLeft: '8px', color: 'darkgreen' }}
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        <DoneIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} />
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>SAVE</b>}
                    </Button>

                    <Button
                        color="error"
                        component={Link}
                        to={{
                            pathname: "/PurchaseOrderIndex",
                            state: { from: "/PurchaseOrderEdit" },
                        }}
                        onClick={() => {
                            localStorage.setItem('shouldReload', 'true');
                        }}
                        className="linkcolor"
                        style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                    >
                        <CloseIcon style={{ color: 'darkred', fontWeight: 'bolder' }} /> CANCEL
                    </Button>


                </div>
            </div>
            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            <div className="w-full flex flex-wrap" style={{ backgroundColor: 'rgba(201, 222, 219, 0.5)', padding: '7px', borderRadius: '10px', marginTop: '-2.00%' }}>

                <div className="w-full pr-4" style={{ marginTop: '-0.11%' }}>

                    <div className="w-full mb-2 flex">

                        <div className="w-3/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="supplierName">
                                Supplier Name
                                <span className="text-red-500">*</span>
                            </label>
                            <AsyncSelect
                                cacheOptions
                                loadOptions={fetchOptions}
                                onInputChange={handleInputChange}
                                onChange={handleCustomerSelect}
                                value={selectedOption}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        height: '37px',
                                        minHeight: '37px',
                                        fontSize: '15px',
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        fontSize: '15px',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        fontSize: '15px',       // Adjust font size for selected value
                                    }),
                                }}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Invoice Type
                                <span className="text-red-500">*</span>
                            </label>

                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.InvoiceTypeName}
                                onChange={handleChange}
                                type="text"
                                name='InvoiceTypeName'
                                readOnly
                                style={{ height: '35px' }}
                            />

                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate">
                                PO Date
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.PurchaseOrderDate)}
                                onChange={handleChange}
                                type="date"
                                name='PurchaseOrderDate'
                                readOnly
                                style={{ height: '35px' }}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                PO No
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={`${formData.PurchaseOrderNo || ''}/${formData.FinYear || ''}`}
                                onChange={handleChange}
                                type="text"
                                placeholder="PO Number"
                                name='PurchaseOrderNo'
                                readOnly
                                style={{ height: '35px' }}
                            />
                        </div>

                    </div>


                    <div className="w-full mb-2 flex">

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Amount || 0}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        color: formData.Amount > 0 ? 'black' : 'inherit', // Highlight in red if DiscountAmount > 0                                      
                                        height: '32px',
                                    }}
                                    name="Amount"
                                    placeholder="Amount"
                                    onChange={handleChange}
                                    readOnly
                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    Amount.
                                </span>
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.DiscountAmount || 0}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        color: formData.DiscountAmount > 0 ? 'black' : 'inherit',                                      
                                        height: '32px',
                                    }}
                                    name="DiscountAmount"
                                    placeholder="Discount Amount"
                                    onChange={handleChange}
                                    readOnly
                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    Disc.
                                </span>
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.TaxableAmount || 0}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        color: formData.CGSTAmount > 0 ? 'black' : 'inherit',                                      
                                        height: '32px',
                                    }}
                                    name="TaxableAmount"
                                    placeholder="Taxable Amount"
                                    onChange={handleChange}
                                    readOnly
                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    Taxable .
                                </span>
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.TaxAmount || 0}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        color: formData.TaxAmount > 0 ? 'black' : 'inherit',                                      
                                        height: '32px',
                                    }}
                                    name="TaxAmount"
                                    placeholder="Tax Amount"
                                    onChange={handleChange}
                                    readOnly
                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    Tax.
                                </span>
                            </div>
                        </div>


                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.FreightAmount}
                                    onChange={handleChange}
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        height: '32px',
                                    }}
                                    name='FreightAmount'

                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    Freight.
                                </span>
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.RoundOff}
                                    onChange={handleChange}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        height: '32px',
                                    }}
                                    name='RoundOff'
                                    readOnly

                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    RoundOff.
                                </span>
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.TotalAmount}
                                    onChange={handleChange}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        height: '32px',
                                    }}
                                    name='TotalAmount'
                                    readOnly

                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    Total.
                                </span>
                            </div>
                        </div>

                    </div>

                    <div className="w-full mb-2 flex">
                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="remarks">
                                Remarks
                                <span className="text-red-500">*</span>
                            </label>
                            <textarea
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Remarks"
                                name="Remarks"
                                value={formData.Remarks}
                                onChange={handleChange}
                                rows={1}
                            />
                        </div>
                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="remarks">
                                Instruction 1
                                <span className="text-red-500">*</span>
                            </label>
                            <textarea
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Instruction"
                                name="Instruction1"
                                value={formData.Instruction1}
                                onChange={handleChange}
                                rows={1}
                            />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="remarks">
                                Instruction 2
                                <span className="text-red-500">*</span>
                            </label>
                            <textarea
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Instruction"
                                name="Instruction2"
                                value={formData.Instruction2}
                                onChange={handleChange}
                                rows={1}
                            />
                        </div>
                    </div>

                    <div className="w-full mb-2 flex">
                        <div className="w-full mr-3">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Weightage">
                                Item Name
                            </label>

                            <AsyncSelect
                                cacheOptions
                                loadOptions={fetchItemOptions}
                                onInputChange={handleItemChange}
                                onChange={handleChangeDrop}
                                value={selectedItemOption}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        height: '37px',         // Adjust height
                                        minHeight: '37px',      // Ensure it doesn't shrink below this
                                        fontSize: '15px',       // Adjust font size
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        fontSize: '15px',       // Adjust font size for input text
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        fontSize: '15px',       // Adjust font size for selected value
                                    }),
                                }}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="MinimumStock">
                                Quantity
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                type="number"
                                name="OrderedQuantity"
                                placeholder="Quantity"
                                value={modalData.OrderedQuantity}
                                onChange={handleModalInputChange}
                                step="0.01"
                                min="0"
                                style={{ height: '35px' }}
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="MinimumStock">
                                Rate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                type="number"
                                name="Rate"
                                placeholder="Rate"
                                value={modalData.Rate}
                                onChange={handleModalInputChange}
                                step="0.01"
                                min="0"
                                style={{ height: '35px' }}
                            />
                        </div>

                        {/* <div className="w-1/4 mr-2">
            <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={saveModalData}
                style={{
                    background: 'linear-gradient(to right, #16423C,green)',
                    color: 'white',
                    fontWeight: 'bolder',
                    textTransform: 'none',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                    maxHeight: '35px',
                    //marginLeft: '5px',
                    marginLeft: '6px',
                    marginTop: '25px'
                }}>
                Add
            </button>
        </div> */}
                        <div className="w-1/5 mr-2">
                            <button className="bg-grey-500  px-4 py-2 rounded" onClick={saveModalData}
                                style={{
                                    color: 'white',
                                    fontWeight: 'bolder',
                                    textTransform: 'none',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                    maxHeight: '35px',
                                    //marginLeft: '5px',
                                    marginLeft: '6px',
                                    marginTop: '25px',
                                    backgroundColor: '#5C7285'
                                }}>
                                <span style={{ marginTop: '-25px', color: 'whitesmoke' }}>+ ADD</span>
                            </button>
                        </div>
                        <div className="w-1/5 mr-2">
                            <input
                                className="shadow text-gray-700 leading-tight"
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={handleSearch}
                                onFocus={() => setIsFocused(true)}
                                onBlur={() => setIsFocused(false)}
                                style={{
                                    width: isFocused ? '230px' : '170px',
                                    height: '30px',
                                    border: '1px solid #ccc',
                                    borderRadius: '15px',
                                    padding: '0 20px',
                                    transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                                    outline: 'none',
                                    borderColor: isFocused ? 'darkcyan' : '#ccc',
                                    boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                                    marginTop: '30px'
                                }}
                            />
                        </div>
                    </div>

                    <div className="w-full mb-2">
                        <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
                            <thead className="bg-gray-300">
                                <tr>
                                    <th className="py-2 px-4 border-b" style={{ fontSize: '13px', color: '#A10035' }}>ITEM NAME</th>
                                    <th className="py-2 px-4 border-b" style={{ fontSize: '13px', color: '#A10035' }}>ORDER QTY</th>
                                    <th className="py-2 px-4 border-b" style={{ fontSize: '13px', color: '#A10035' }}>RATE</th>
                                    <th className="py-2 px-4 border-b" style={{ fontSize: '13px', color: '#A10035' }}>DIS %</th>
                                    <th className="py-2 px-4 border-b" style={{ fontSize: '13px', color: '#A10035' }}>DIS ₹</th>
                                    <th className="py-2 px-4 border-b" style={{ fontSize: '13px', color: '#A10035' }}>AMOUNT</th>
                                    <th className="py-2 px-4 border-b" style={{ fontSize: '13px', color: '#A10035' }}></th>
                                </tr>
                            </thead>

                            <tbody>
                                {filteredData.map((item, index) => {
                                    const details = orderDetails[item.Id] || {};
                                    const defaultOrderQty = item.ApprovedQuantity || 0;
                                    const orderQty = orderQuantities[item.Id] || defaultOrderQty;


                                    return (
                                        // <tr key={index} className="border-b">
                                        <tr key={index} className="border-b"
                                            style={{
                                                backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF',
                                                borderBottom: '1px solid #E0E0E0',
                                                transition: 'transform 0.2s ease-in-out',
                                                cursor: 'pointer',
                                            }}
                                            onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                        >

                                            <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '3px', width: '500px' }}>{item.ItemName}</td>

                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    type="number"
                                                    value={item.OrderedQuantity || item.OrderedQuantity}
                                                    onChange={(e) => handleCalculation(e, index, 'OrderedQuantity')}
                                                    className="w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                                    style={{
                                                        fontSize: '13px',
                                                        fontWeight: 'bold',
                                                        backgroundColor: (item.OrderedQuantity || 0) > 0 ? '#FFEFEF' : '#D3F1DF',
                                                        textAlign: 'right'
                                                    }}
                                                    min="0"
                                                    step="0.01"
                                                    aria-label={`Order quantity for item ${item.Id}`}
                                                    name="OrderedQuantity"
                                                />
                                            </td>

                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    value={item.Rate || 0}
                                                    onChange={(e) => handleCalculation(e, index, 'Rate')}
                                                    className="w-full px-2 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                    type="number"
                                                    step="0.01"
                                                    min="0"
                                                    name="Rate"
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    value={item.DiscountPercentage || 0}
                                                    onChange={(e) => handleCalculation(e, index, 'DiscountPercentage')}
                                                    className="w-full px-2 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                    type="number"
                                                    name="DiscountPercentage"
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    value={item.DiscountAmount || 0}
                                                    onChange={(e) => handleCalculation(e, index, 'DiscountAmount')}
                                                    readOnly
                                                    className="w-full px-2 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    value={item.TotalAmount || 0}
                                                    onChange={(e) => handleCalculation(e, index, 'TotalAmount')}
                                                    readOnly
                                                    className="w-full px-2 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#D3F1DF', textAlign: 'right' }}
                                                />
                                            </td>
                                            <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '1px', textAlign: 'center', width: '65px' }}>
                                                <Tooltip
                                                    title="Delete Purchase Order"
                                                    componentsProps={{
                                                        tooltip: {
                                                            sx: {
                                                                backgroundColor: 'darkolivegreen',
                                                                color: 'white',
                                                                border: '1px solid white',
                                                                fontWeight: 'bold',
                                                                boxShadow: 2,
                                                                fontSize: '0.875rem',
                                                            },
                                                        },
                                                    }}
                                                >

                                                    <DeleteIcon style={{ color: 'brown', cursor: 'pointer', marginLeft: '20px' }} onClick={() => openConfirmDialog(index)} />
                                                </Tooltip>

                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                            <Modal open={confirmDialogOpen} onClose={closeConfirmDialog} style={{ marginTop: '10%' }}>
                                <div style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', margin: 'auto', width: '30%', textAlign: 'center' }}>
                                    <h5>Confirm Delete</h5>
                                    <p>Are you sure you want to delete this item?</p>
                                    <Button style={{ margin: '8px', color: 'red' }} onClick={handleDelete}>Delete</Button>
                                    <Button style={{ margin: '8px', color: 'grey' }} onClick={closeConfirmDialog}>Cancel</Button>
                                </div>
                            </Modal>
                        </table>
                    </div>

                </div>


            </div>
        </div>

    );
};

export default PurchaseOrderEdit;
